module.exports = __webpack_public_path__ + "static/media/ios.e0178e5f.png";